@import '../../themes/capsule.globals';

:host {
  --container-padding-top: 4px;
  --container-padding-end: 4px;
  --container-padding-bottom: 4px;
  --container-padding-start: 4px;
  --container-border-width: 2px;
  --container-border-color: var(--cpsl-color-iconGroup-border);
  --container-background: var(--cpsl-color-iconGroup-surface);

  --icon-height: 15px;
  --icon-width: 15px;
  --icon-item-color: var(--cpsl-color-iconGroup-icon-default);

  display: flex;
  width: auto;
  padding-right: calc(var(--container-border-width) * 3);
}

.icon-container {
  @include padding(var(--container-padding-top), var(--container-padding-end), var(--container-padding-bottom), var(--container-padding-start));

  margin-right: calc(var(--container-border-width) * -3);
  border-style: solid;
  border-width: var(--container-border-width);
  border-color: var(--container-border-color);
  border-radius: 1000px;
  background: var(--container-background);

  transition: margin 250ms;

  cpsl-icon {
    --height: var(--icon-height);
    --width: var(--icon-width);
    --icon-color: var(--icon-item-color);
  }

  &.expanded {
    margin-right: calc(var(--container-border-width) * -1);
  }

  &.disabled {
    cpsl-icon {
      --icon-color: var(--cpsl-color-iconGroup-icon-disabled);
    }
  }
}
